exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swal2-icon.swal2-success .swal2-success-ring {\n  border: 0.25em solid #36b729;\n  background: #36b729;\n}\n.swal2-icon.swal2-success [class^=swal2-success-line] {\n  z-index: 3;\n  background-color: #ffffff;\n}", ""]);

// exports
